import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    fontSize: theme.typography.h5.fontSize,
    borderRadius: '0.9375rem',
    fontWeight: theme.typography.h1.fontWeight,
    textTransform: 'uppercase',
    padding: theme.spacing(0.75, 1.5),
    '&.completed': {
      color: theme.palette.opaque.dark,
      border: `1px solid ${theme.palette.opaque.dark}`,
    },
    '&.active': {
      background: '#E8FAF7',
      color: theme.palette.loading.main,
      border: `1px solid ${theme.palette.loading.main}`,
    },
    '&.expired': {
      color: theme.palette.text.tertiary,
      border: `1px solid ${theme.palette.text.tertiary}`,
    },
    '&.restricted': {
      color: theme.palette.error.main,
      border: `1px solid ${theme.palette.error.main}`,
    },
  },
}))
